import { ReactComponent as Quastion } from 'assets/icons/header/question.svg';
import './styles.scss';


const AskExpert = ({ text }) => {
    const handleClick = () => {
        // @ts-ignore
        window.MavaWebChatToggle()
    };

    return (
        <button onClick={handleClick} className='ask-expert' id="mava-webchat-launcher">
            <Quastion />
            {text}
        </button>
    );
}

export default AskExpert;